import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import GlobalButton from "../../../shared/utils/GlobalButton";

const ClintRecceRejectedModal = ({ open, onClose, onSubmit }) => {
  const [clientrejectionReason, setClientrejectionReason] = useState("");

  const handleSubmit = () => {
    onSubmit(clientrejectionReason); // Pass the entered name back to the parent
    setClientrejectionReason(""); // Clear the input field
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <label className="my-2">Recce Ignore Reason (Optional):</label>
        <TextField
          autoFocus
          margin="dense"
          label="Enter Reason"
          type="text"
          fullWidth
          value={clientrejectionReason}
          onChange={(e) => setClientrejectionReason(e.target.value)}
          placeholder="Optional - you can leave this empty"
        />
      </DialogContent>
      <DialogActions>
        <GlobalButton variant="secondary" onClick={onClose}>
          {`Cancel`}
        </GlobalButton>
        <GlobalButton variant="warning" onClick={handleSubmit}>
          {`Ignore`}
        </GlobalButton>
      </DialogActions>
    </Dialog>
  );
};

export default ClintRecceRejectedModal;
